import { createAction, props } from "@ngrx/store";

export const play = createAction(
  "[Playback] play",
  props<{
    playingUrl: string;
  }>()
);
